import Decimal from 'decimal.js';

import {
  LiabilityPaymentFrequency,
  LiabilityPaymentKind,
} from '@/types/schema';
import { PathsOf } from '@/types/subform';

export interface LiabilityFormShape {
  // _showExpandedPaymentDetails is a UI-only value that doesn't
  // get persisted to the data model.
  _showExpandedPaymentDetails: boolean;

  name: string;
  issuerId: string;
  recipientId: string;
  outstandingBalance: Decimal | null;
  balanceAsOfDate: Date | null;
  paymentFrequency: LiabilityPaymentFrequency;
  interestRate: Decimal | null;
  termStartDate: Date | null;
  termEndDate: Date | null;
  paymentKind: LiabilityPaymentKind;
  paymentAmount: Decimal | null;
  notes: string;

  // We allow the user to specify a different payment source for the liability. If that's the case,
  // we store the id of the alternate source here.
  hasDifferentPaymentSource: boolean;
  alternateSourceId: string | null;

  // When linked to an integration liability, this holds the integration liability ID.
  integrationLiabilityId: string | null;
}

export type LiabilityFormPaths = PathsOf<LiabilityFormShape>;

export const defaultValues: LiabilityFormShape = {
  _showExpandedPaymentDetails: false,
  name: '',
  issuerId: '',
  recipientId: '',
  balanceAsOfDate: null,
  outstandingBalance: null,
  paymentFrequency: LiabilityPaymentFrequency.Monthly,
  interestRate: null,
  termStartDate: null,
  termEndDate: null,
  paymentKind: LiabilityPaymentKind.Amortized,
  paymentAmount: null,
  notes: '',
  hasDifferentPaymentSource: false,
  alternateSourceId: '',
  integrationLiabilityId: null,
};

export const NO_LIABILITY_SOURCE_RECIPIENT_VALUE_DISPLAY = 'External';
export const NO_LIABILITY_SOURCE_RECIPIENT_VALUE_SENTINEL = '__EXTERNAL__';
